import { App } from '@capacitor/app'
import { defineNuxtPlugin, useNuxtApp, useRouter } from 'nuxt/app'

export default defineNuxtPlugin(() => {
  App.addListener('backButton', handleBack)
})

export const handleBack = () => {
  const nuxtApp = useNuxtApp()
  const router = useRouter()
  const {
    $platform: {
      native: { scanner },
      isNative
    }
  } = nuxtApp
  if (isNative && scanner?.isScanning) {
    scanner.stopScan()
    return
  }
  router.back()
}
